module.exports = __webpack_public_path__ + "img/VRtoB1.dafcb308.jpg";